import { styled } from 'next-yak';

import { spaceXS } from '@xing-com/tokens';

export const Pricing = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceXS};
`;
